export default __webpack_public_path__ + "static/media/undraw_finance.a81b91d2.svg";